/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2023, Zumper
 * @description GreenCheckMark
 */

import * as React from 'react'

import greenCheck from '../../../img/greenCheck.svg'
import { ImgIconProps } from '../../../types'

export const GreenCheckMark = ({ alt = 'Success', size = 20, ...rest }: ImgIconProps) => (
  <img alt={alt} height={size} loading="lazy" src={greenCheck} width={size} {...rest} />
)
